// extracted by mini-css-extract-plugin
export default {"cancelLink":"cP-z"};